import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { TRANSLATIONS } from "./translations";

const STORAGE_KEY = "inateb_lang";
const SUPPORTED = ["de", "en"];

// Ermittelt die Startsprache: gespeicherte Wahl > Browser-Sprache > Deutsch
function detectInitialLang() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED.includes(stored)) return stored;
  } catch (e) {
    // localStorage nicht verfügbar
  }
  if (typeof navigator !== "undefined") {
    const langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (const l of langs) {
      if (!l) continue;
      const code = l.toLowerCase().slice(0, 2);
      if (code === "de") return "de";
      if (code === "en") return "en";
    }
    // Browser weder DE noch EN -> Standard Englisch (internationales Publikum)
    return "en";
  }
  return "de";
}

const LanguageContext = createContext({ lang: "de", setLang: () => {}, toggle: () => {}, t: TRANSLATIONS.de });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => detectInitialLang());

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      /* ignore */
    }
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const setLang = useCallback((next) => {
    if (SUPPORTED.includes(next)) setLangState(next);
  }, []);

  const toggle = useCallback(() => {
    setLangState((prev) => (prev === "de" ? "en" : "de"));
  }, []);

  const value = useMemo(
    () => ({ lang, setLang, toggle, t: TRANSLATIONS[lang] || TRANSLATIONS.de }),
    [lang, setLang, toggle]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  return useContext(LanguageContext);
}

export default LanguageContext;
